// custom typefaces
import "typeface-montserrat"
import "typeface-merriweather"

// import "prismjs/themes/prism.css"
import "./src/utils/kyr-theme.css"